import Hero from "./Hero";
import FeaturesSlider from "./FeaturesSlider";
import Features from "../Treatments/Services";
import WhyChooseUs from "./WhyChooseUs";
import Services from "../Treatments/Services";
import Reviews from "../Reviews/Reviews";
import Specializations from "./Specializations";

export default function Home() {
  return (
    <div className="bg-[#faf6ee]">
      <Hero />
      {/* <Features /> */}
      {/* <Services /> */}
      <FeaturesSlider />
      <Specializations />
      <WhyChooseUs />
      <Reviews />
    </div>
  );
}
